import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'

// Import our custom CSS
import './scss/styles.scss'

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'

const app = createApp(App)

app.directive('focus', {
  // When the bound element is mounted into the DOM...
  mounted(el) {
    // Focus the element
    el.focus()
  }
})

Sentry.init({
  app,
  dsn: 'https://0089d5dc97bc66a1809bd76d2fc1486a@o99343.ingest.us.sentry.io/4507047165165568',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false
    })
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

app.use(createPinia())
app.use(router)

export const i18n = createI18n({
  locale: localStorage.getItem('language') || navigator.language.split('-')[0],
  legacy: false,
  messages: {
    en: {
      role: {
        owner: 'Owner',
        admin: 'Admin',
        member: 'User'
      }
    },
    ru: {
      role: {
        owner: 'Владелец',
        admin: 'Администратор',
        member: 'Пользователь'
      }
    }
  },
  pluralizationRules: {
    ru: function (choice, choicesLength) {
      // this === VueI18n instance, so the locale property also exists here

      if (choice === 0) {
        return 0
      }

      const teen = choice > 10 && choice < 20
      const endsWithOne = choice % 10 === 1

      if (choicesLength < 4) {
        return !teen && endsWithOne ? 1 : 2
      }
      if (!teen && endsWithOne) {
        return 1
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2
      }

      return choicesLength < 4 ? 2 : 3
    }
  }
})

watch(
  () => i18n.global.locale.value,
  (newVal) => {
    localStorage.setItem('language', newVal)
  }
)

app.use(i18n)

app.mount('#app')
